<template>
  <a-modal
    class="client-modal-wrapper"
    width="702px"
    :mask-closable="false"
    :visible="productVisible"
    :footer="null"
    :title="title"
    @cancel="$emit('onCancel')"
  >
    <basic-form
      ref="basicForm"
      :form-data="formData"
    >
      <template #title>
        <a-input
          v-decorator="[
            'title',
            {
              rules: [
                {
                  required: true,
                  message: '请输入产品名称',
                },
              ],
            },
          ]"
          placeholder="请输入产品名称"
        />
      </template>
      <template #spec>
        <a-input
          v-decorator="[
            'spec',
            {
              rules: [
                {
                  required: true,
                  message: '请输入产品规格',
                },
              ],
            },
          ]"
          placeholder="请输入产品规格，多个用英文;分隔"
          extra="多个用英文;分隔"
        />
        <div class="ant-form-extra">多个规格请用英文;分隔</div>
      </template>
      <!-- <template #product_form>
        <a-select
          v-decorator="[
            'product_form',
            { rules: [{ required: true, message: '请选择产品剂型' }] },
          ]"
          placeholder="请选择产品剂型"
        >
          <a-select-option
            v-for="item in productFormData"
            :key="item.key"
            :value="item.key"
          >
            {{ item.name }}
          </a-select-option>
        </a-select>
      </template>
      <template #nmpn>
        <a-input
          v-decorator="[
            'nmpn',
            { rules: [{ required: true, message: '请输入国药准字' }] },
          ]"
          placeholder="请输入国药准字"
        />
      </template> -->
	  <template #department_id>
	    <a-tree-select
	      v-decorator="[
	        'department_id',
	        { rules: [{ required: true, message: '请选择科室' }] }
	      ]"
	      :tree-data="sectionData"
		  multiple
	      placeholder="请选择科室"
	    />
	  </template>
      <template #describe>
        <a-textarea
          v-decorator="[
            'describe',
            { rules: [{ required: true, message: '请输入产品说明' }] },
          ]"
          rows="6"
          placeholder="请输入产品说明"
          maxlength="150"
        />
      </template>
    </basic-form>
    <slot />
  </a-modal>
</template>

<script>
import { formData } from '../data/index';
export default {
  props: ['productVisible', 'title'],
  data() {
    return {
      formData,
      productFormData: [],
	   sectionData: [],
    };
  },
  computed: {
    checkKey() {
      return this.checkKeyProp;
    },
  },
  mounted() {
    // 获取产品剂型
    this.getSystemConfig();
	// 获取科室
	this.getSectionData();
  },
  methods: {
    // 获取产品剂型
    async getSystemConfig() {
      let result = await this.$http.post('/system/getConfigs');
      if (result.data.status === 1) {
        this.productFormData = result.data.data.product_form;
      }
    },
	// 获取科室数据
	async getSectionData() {
	  let result = await this.$http.post('/system/getDepartmentList');
	  if (result.data.status === 1) {
	    let data = result.data.data.data_list;
	    this.sectionData = [
	      ...this.sectionData,
	      ...this.dealData(JSON.parse(JSON.stringify(data))),
	    ];
	  }
	},
	dealData(data) {
	  data.forEach((item) => {
	    item.title = item.name;
	    item.key = item.id;
	    item.value = String(item.id);
	    item.selectable = false;
	    item.children = item.child_list;
	    item.child_list.forEach((child) => {
	      child.title = child.name;
	      child.key = child.id;
	      child.value = String(child.id);
	    });
	  });
	  return data;
	},
  },
};
</script>
<style lang="scss" scoped>
.client-modal-wrapper {
  .textarea {
    font-size: 12px;
    font-weight: 400;
    color: rgba(86, 92, 102, 1);
    position: relative;
    top: -37px;
    right: -550px;
  }
}
</style>
